import jwtDecode from 'jwt-decode';

const MILLISECONDS = 1000;
export default (token) => new Date(jwtDecode(token).exp * MILLISECONDS);
